module.exports = __webpack_public_path__ + "static/img/a055.2f2ede4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a055.jpg
// module id = dTNA
// module chunks = 0